<template>
    <div class="BlockQuote bg--blue-charcoal">
        <div class="BlockQuote__icon">
            <BaseIcon
                icon="quote-symbol"
                color="white"
            />
        </div>
        <blockquote>
            {{ quote }}
        </blockquote>
        <cite
            v-if="cite"
        >
            {{ cite }}
        </cite>
    </div>
</template>

<script>
export default {
    name: 'BlockQuote',
    props: {
        quote: {
            type: String,
            required: true
        },
        cite: {
            type: String,
            default: null
        }
    },
}
</script>
<style lang="scss">

    .BlockQuote {
        min-height: 300px;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 5rem 2.5rem;

        @include media-query(lap-and-up) {
            min-height: 400px;
            padding: 110px 2rem;
        }

        blockquote {
            max-width: 800px;
            color: #fff;
            text-align: center;
            font-family: $fancy-font-family;
            text-transform: none;
            font-weight: 400;
            font-size: 2.2rem;
            line-height: 1.1em;

            @include media-query(lap-and-up) {
                font-size: 2.8rem;
            }
        }

        cite {
            margin-top: 2.2em;
            font-style: normal;
            color: #fff;
            text-align: center;
            max-width: 500px;
        }
    }

    .BlockQuote__icon {
        position: absolute;
        left: 0;
        top: 0;
        padding: 0.7em;
        background-color: rgba(getColor('white'), 0.2);
        font-size: 23px;

        @include media-query(lap-and-up) {
            font-size: 34px;
        }
    }

</style>
